import { Component, Input, OnChanges } from '@angular/core';
import { ChartData, ChartOptions, ChartType } from 'chart.js';

@Component({
  selector: 'app-small-pie-chart',
  templateUrl: './small-pie-chart.component.html',
  styleUrls: ['./small-pie-chart.component.scss']
})
export class SmallPieChartComponent implements OnChanges {

  public pieChartType: ChartType = 'pie';
  public pieChartData: ChartData<'pie', number[], string> = {
    labels: ['', ''],
    datasets: [{
      data: [0, 100],
      backgroundColor: this.getBackgroundColor(),
      borderColor: 'transparent'
    }]
  };
  public pieChartOptions: ChartOptions<'pie'> = {
    responsive: false,
    plugins: {
      tooltip: {
        enabled: false
      },
      legend: {
        display: false
      }
    }
  };

  @Input() percentage: number = 0;
  @Input() lightBg = false;
  @Input() background: [string, string] = ['rgba(255, 255, 255, 1)', 'rgba(104, 113, 136, 0.7)'];

  ngOnChanges() {
    const normalized = Math.max(0, Math.min(100, Number(this.percentage) || 0));
    const backgroundColor = this.getBackgroundColor();

    this.pieChartData = {
      labels: ['', ''],
      datasets: [{
        data: [normalized, 100 - normalized],
        backgroundColor,
        borderColor: 'transparent'
      }]
    };
  }

  private getBackgroundColor(): [string, string] {
    return this.lightBg ? ['rgba(104, 113, 136, 0.7)', 'rgba(255, 255, 255, 1)'] : this.background;
  }

}
